import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { sourceUrl } from '@angular/compiler';
import { ParametricModal } from 'app/infrastructure/model/interfaces/parametricModal.interface';
import { MappingPaymentAttribute } from 'app/infrastructure/model/classes/paymentGateway.class';

@Component({
  selector: 'sx-mapping-payment',
  templateUrl: './mapping.payment.component.html'
})
export class MappingPaymentComponent implements ParametricModal {
  aRoute: ActivatedRoute;
  systemCode: string;
  businessCode: string;
  productCode: string;
  kind: string;
  pgcode : string;
  additionalParameters: string[]; 

  newMapping = {
    attributeCodeFrom: undefined,
    attributeCodeTo: undefined
  } as MappingPaymentAttribute;

  @Input() selected: MappingPaymentAttribute[] = [];

  constructor(
    private paymentSrv: PaymentGatewayService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
  }

  setParameters(elements: string[]): void {
    this.additionalParameters = elements;

    this.systemCode = this.additionalParameters[0];
    this.businessCode = this.additionalParameters[1];
    this.productCode = this.additionalParameters[2];
    this.kind = this.additionalParameters[3];
    this.pgcode = this.additionalParameters[4];
  }

  save() {
    this.activeModal.close(this.selected);
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  scan() {
    this.paymentSrv
      .scanMapping(this.systemCode, this.businessCode, this.productCode,this.kind,this.pgcode)
      .toPromise()
      .then(data => this.mergeMapping(data));
  }

  addNewMapping() {
    const attribute = this.selected.find(mAttr =>
      this.sameAttributeCodes(mAttr, this.newMapping)
    );
    if (!attribute) {
      const newMappingCopy = {
        attributeCodeFrom: `${this.newMapping.attributeCodeFrom}`,
        attributeCodeTo: `${this.newMapping.attributeCodeTo}`
      } as MappingPaymentAttribute;
      this.selected.push(newMappingCopy);
    } else {
      this.copyMappingAttribute(attribute, this.newMapping);
    }
    this.newMapping.attributeCodeFrom = undefined;
    this.newMapping.attributeCodeTo = undefined;
  }

  removeMapping(attributeMapping) {
    const attributeIndex = this.selected.findIndex(mAttr =>
      this.sameAttributeCodes(mAttr, attributeMapping)
    );
    if (attributeIndex !== -1) {
      this.selected.splice(attributeIndex, 1);
    }
  }

  private mergeMapping(scannedValues: MappingPaymentAttribute[]) {
    scannedValues.forEach(scannedValue => {
      const attribute = this.selected.find(mAttr =>
        this.sameAttributeCodes(mAttr, scannedValue)
      );
      if (!attribute) {
        this.selected.push(scannedValue);
      } else {
        this.copyMappingAttribute(attribute, scannedValue);
      }
    });
  }

  private sameAttributeCodes(
    lhs: MappingPaymentAttribute,
    rhs: MappingPaymentAttribute
  ): boolean {
    return (
      lhs.attributeCodeTo.toUpperCase() === rhs.attributeCodeTo.toUpperCase()
    );
  }

  private copyMappingAttribute(
    target: MappingPaymentAttribute,
    source: MappingPaymentAttribute
  ): void {
    target.attributeCodeFrom = source.attributeCodeFrom;
    target.attributeCodeTo = source.attributeCodeTo;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/paymentGateways/mapping/mapping.payment.component.ts